import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import { ISignInRequest } from "app/api/types/Auth";
import { IAuthResponse } from "app/api/types/User";

import api from "app/api/requests/Auth";

export const SIGN_IN_REQUEST = "SIGN_IN_REQUEST";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_FAIL = "SIGN_IN_FAIL";

export const signIn = (data: ISignInRequest) => (dispatch: any): any => {
  dispatch({ type: SIGN_IN_REQUEST });
  return api
    .signIn(data)
    .then((response: AxiosResponse) => {
      const auth: IAuthResponse = get(response, "data", {});

      sessionStorage.setItem("token", auth.token);

      dispatch({ type: SIGN_IN_SUCCESS, payload: auth });

      return auth;
    })
    .catch(err => {
      dispatch({
        type: SIGN_IN_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
